const projects = [
  {
    id: 1,
    name: "Calculator",
    tags: "HTML , CSS, SASS , JavaScript",
    img: "calculator-preview.svg",
    description:
      "The aim of this project was to create a browser-based calculator using modern JavaScript programming techniques and DOM manipulation with practice of using Git and Github. It allows users to intereact with the calculator and do the basic calculation.",
    preview: "https://ellaellac.github.io/Calculator-Project/",
    code: "https://github.com/ellaellac/Calculator-Project",
  },
  {
    id: 2,
    name: "Falling Objects Game",
    tags: "HTML , CSS, SASS , JavaScript",
    img: "game-preview.svg",
    description:
      "The aim of this project was to create a fully functional browser-based game using modern JavaScript programming techniques and DOM manipulation. Game design and rules are based on my idea. Player will play as Snow White to avoid the falling objects.",
    preview: "https://ellaellac.github.io/Game-Project/",
    code: "https://github.com/ellaellac/Game-Project",
  },
  {
    id: 3,
    name: "Punk API Project",
    tags: "React, SASS, CSS",
    img: "punk-preview.svg",
    description:
      "The aim of this project was to build a React application that fetchs data from an external public API. Data of beers are shown on each card. It allows users to serach beers by name and filter by attributes.",
    preview: "https://punk-api-project-m7vf-1yzibf1mz-ellaellacs-projects.vercel.app/",
    code: "https://github.com/ellaellac/punk-api-project",
  },
  {
    id: 4,
    name: "Local Business Project",
    tags: "React, SASS, Agile, Unit testing",
    img: "local.png",
    description:
      "The project was based on the client's request to build an app that can search the local businesses by location. The design was based on the client's figma and the functions were built and tested in an agile team. ",
    preview: "https://local-c70c0.firebaseapp.com/",
    code: "https://github.com/nology-tech/local",
  },
  {
    id: 5,
    name: "Hungman Project",
    tags: "Java",
    img: "hangman.png",
    description:
      "The project was built entirely in Java. The core functions of the game are to interact with the user by allowing user's input and recording the attempts. Letter of the word is displayed with blanks and the life of the player is shown after each attempt.",
    preview: "https://github.com/ellaellac/hungman-java-project",
    code: "https://github.com/ellaellac/hungman-java-project",
  },
  {
    id: 6,
    name: "Snap Project",
    tags: "Java",
    img: "snap.png",
    description:
      "The project was built entirely in Java. The game interacts with the player by playing with the computer. The user can press the enter key to take turn and has 2 seconds to win the game by typing snap when 2 cards with the same symbols shown in a row. ",
    preview: "https://github.com/ellaellac/snap-java-project",
    code: "https://github.com/ellaellac/snap-java-project",
  },
  {
    id: 7,
    name: "Full-stack Food App Project",
    tags: "React, Sass, Spring Boot, SQL",
    img: "food-app.png",
    description:
      "This is a Full Stack Project using React, Spring Boot, MySQL. The Menu App allows users to CRUD ( Create, Read, Update, Delete) a local database. Users can navigate different pages to view, add and edit Menu",
    preview:
      "https://user-images.githubusercontent.com/117093750/219903238-b90f2260-829e-43ca-826a-0680ff69a427.mp4",
    code: "https://github.com/ellaellac/full-stack-project",
  },
];

export default projects;
